import React from 'react';
import { MyFavoritesList } from '../system-modules/favorites/components';

const MyFavoritesPage = () => {
  return (
    <div className="max-w-6xl mx-auto p-6">
      <MyFavoritesList />
    </div>
  );
};

export default MyFavoritesPage;
